export const subDomainAsterisk = /\*\./;
export const portNumberAsterisk = /\:\*$/;

export const removeAsterisks = (value: string) => {
    return value.replace(subDomainAsterisk, '').replace(portNumberAsterisk, '');
};

export const stripProtocol = (value: string) => {
    const protocol = /^[a-z]*\:?\/\//;

    const matches = value.match(protocol);
    const protocolValue = matches?.[0].replace(/\/\/$/, '') ?? '';
    const newValue = value.replace(protocol, '');

    return [newValue, protocolValue];
};

export const checkIfSubdomain = (subdomain: string, host: string) => {
    const subdomainParts = subdomain.split('.');
    const urlParts = host.split('.');

    if (subdomainParts.length < urlParts.length) {
        return false;
    }

    while (urlParts.length > 0) {
        const urlPart = urlParts.pop()!;
        const subdomainPart = subdomainParts.pop()!;

        if (subdomainPart !== urlPart) {
            return false;
        }
    }

    return true;
};
